import React from 'react';
import Configurator from './Configurator.jsx';
import Button from './ui/button/Button.jsx';
import styles from './EnclosureConfigurator.styl';
import Image from './ui/features/Image.jsx';

/**
 * Конфигуратор шкафов
 */
class EnclosureConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.onSwitchConfigurator = this.onSwitchConfigurator.bind(this);
	}


	getType() {
		return 'enclosure';
	}

	onSwitchConfigurator(type) {

		if (this.props.onSwitchConfigurator) {
			this.props.onSwitchConfigurator(type,this.state);
		}
	}

	getCustomElements() {
		let elements = [];

		elements.push(
			<Button
				buttonStyle={styles.btnDwgDownload}
				buttonDisabledStyle={styles.btnDwgDownloadDisabled}
				iconStyle={styles.btnDwgDownloadIcon}
				text="Скачать чертеж dwg"
				disabled={!this.state.item || !this.state.item.dwg}
				onClick={() => this.onDwgDownload(this.state.item)}
				key="download"
			/>
		);

		elements.push(
			<Button
				buttonStyle={styles.btnRevitDownload}
				iconStyle={styles.btnDwgDownloadIcon}
				text="Скачать базу для Revit"
				onClick={this.onRevitDownload}
				key="download_revit"
			/>
		);
		elements.push(

			<Button
				buttonStyle={styles.btnAccessories}
				iconStyle={styles.btnAccessoriesIcon}
				text="Перейти к просмотру аксессуаров"
				onClick={()=>this.onSwitchConfigurator('enclosure_accessory')}
				key="accessory"
			/>

		);
		elements.push(

			<Button
				buttonStyle={styles.btnAddEnclosureConf}
				iconStyle={styles.btnAddEnclosureConfIcon}
				text="Перейти к подбору заказных шкафов"
				onClick={()=>this.onSwitchConfigurator('enclosure_order')}
				key="accessory"
			/>

		);


		elements.push(<span className={styles.filter_label_ip} key="filter_label_ip">Степень защиты IP:</span>);
		elements.push(<span className={styles.filter_label_add_door} key="filter_label_add_door">Дополнительная дверь:</span>);
		elements.push(
			<Image
				className={styles.itemImg}
				url={this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].ImgJpeg  && this.state.itemInfo[0].ImgJpeg[0].file_ref.uri ? this.state.itemInfo[0].ImgJpeg[0].file_ref.uri : null}
			/>
		);
		elements.push(<div><div className={styles.itemInfoBG}/>
			{this.state.item ? (
				<a href={`https://qr.iek.group/${this.state.item.article}`}
					 target="_blank">
					<div className={styles.itemInfo}>
						<div className={styles.itemInfo_Article}>{this.state.item.article}</div>
						<div>{this.state.item.name}</div>
					</div>
				</a>
			) : (
				<div className={styles.itemInfoNoArticle}/>
			)}</div>);
		elements.push(<div>{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].Description ? (
			<div className={styles.description}>{this.state.itemInfo[0].Description[0].desc_ru}</div>
		) : (
			<div className={styles.descriptionEmpty}/>
		)}</div>)

		return elements;
	}

	getCustomStyles() {
		return styles;
	}

	getFilterTitles() {
		return {
			'color': 'По желанию заказчика возможно нанесения покрытия любого цвета'
		};
	}

	onDwgDownload(item) {
		if (!item || !item.dwg) {
			return;
		}

		window.location = `itkcfg.php?type=${this.getType()}&action=getDwg&article=${item.article}`;
	}

	onRevitDownload() {
		window.location = 'http://iek.ru/products/standard_solutions/download/shkafy-i-aksessuary-itk_r14.zip';
	}

	onFilterChange(prop, value) {
		if ('series' === prop) {
			this.filter = {};
		}

		super.onFilterChange(prop, value);
	}
}

export default EnclosureConfigurator;



// WEBPACK FOOTER //
// ./src/react/EnclosureConfigurator.jsx